import { getAccurateAgent } from '@egjs/agent'

interface FloUserAgent {
  browser?: {
    name: string
    version: string
  }
  os?: {
    name: string
    version: string
  }
}

class UserAgent {
  private agentInfo: FloUserAgent | null = {} as FloUserAgent

  public async init(): Promise<void> {
    this.agentInfo = await UserAgent.getAgentInfo()
  }

  private static async getAgentInfo() {
    return getAccurateAgent()
  }

  public get osName(): string {
    return this.agentInfo?.os?.name || 'Undefined OS Name'
  }

  public get osVersion(): string {
    return this.agentInfo?.os?.version || 'Undefined OS Version'
  }

  public get browserName(): string {
    return this.agentInfo?.browser?.name || 'Undefined Browser Name'
  }

  public get browserVersion(): string {
    return this.agentInfo?.browser?.version || 'Undefined Browser Version'
  }
}

export default new UserAgent()
